﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const app_commons_1 = require("@its-suite/app-commons");
const operational_context_client_1 = require("@its-suite/operational-context-client");
const __1 = require("..");
class CommonConfigureAppSaga {
    static readToken() {
        return new operational_context_client_1.JwtStorage().readToken();
    }
    static getMicroserviceUrl(baseUrl, plugins, pluginName) {
        let url;
        let plugin = plugins.find(p => p.name === pluginName);
        if (plugin) {
            url = `${baseUrl}${plugin.relativeUri}`;
        }
        return url;
    }
    static *setupAppLocale(locale, resources) {
        const commonsResources = resources.map((resource) => ({ fileName: resource.fileName, stringLibrary: resource.stringLibrary }));
        yield effects_1.call(app_commons_1.ConfigureLocaleSagaFunctions.setupAppLocale, locale, commonsResources, __1.ownGetTranslate);
    }
    static *fillSession() {
        let jwtManager = new operational_context_client_1.JwtManager();
        let loginClient = new operational_context_client_1.LoginClient();
        let token = yield effects_1.call([loginClient, loginClient.renewToken]);
        let payload = jwtManager.save(token);
        yield effects_1.put(__1.SessionModule.actionCreators.setSession(payload));
        console.log(`RenewTokenSaga set session`);
    }
    static getMicroservicesConfiguration(plugins, appConfig) {
        let microservicesConfig = [];
        plugins.filter(microservice => !microservice.blocked)
            .forEach(microservice => {
            const urlBuilderForMicroservice = microservice.relativeUri ? `${appConfig.BaseUrl}${microservice.relativeUri}` : undefined;
            microservicesConfig.push({
                name: microservice.name,
                url: urlBuilderForMicroservice,
                hasExtensibleEntities: microservice.hasExtensibleEntities,
                hasInjectionPoints: microservice.hasInjectionPoints
            });
        });
        return microservicesConfig;
    }
    static configureOperationalContextClient(configUri) {
        return new Promise((resolve, reject) => {
            fetch(configUri)
                .then(response => response.json())
                .then((appConfig) => {
                console.info(`Fetch config: ${JSON.stringify(appConfig)}`);
                let operationalContextUrl = `${appConfig.BaseUrl}${appConfig.OperationalContextRelativeUrl}`;
                operational_context_client_1.OperationalContextClientConfiguration.init(operationalContextUrl, CommonConfigureAppSaga.readToken);
                resolve(appConfig);
            })
                .catch(error => {
                reject(error);
            });
        });
    }
}
exports.CommonConfigureAppSaga = CommonConfigureAppSaga;
//# sourceMappingURL=CommonConfigureAppSaga.js.map